import Vue from 'vue'
import i18n from '@/scripts/app-configs/i18n-config'

const generateDefaultState = () => {
  const defaultState = {
    list: { pp: { patients: [], total: 0 } },
    fetching: {
      pp: {
        isFetching: null,
        completed: false,
      },
    },
    pendingActionsByUUID: {},
    selectedPatient: null,
  }

  return defaultState
}

export default {
  namespaced: true,
  state: generateDefaultState(),
  getters: {
    getTodoListByType: (state) => (listContext) => state.list[listContext],
    listIsFetching: (state) => (listContext) => {
      return state.fetching[listContext].isFetching || state.fetching[listContext].isFetching === null
    },
    hasPendingAction: (state) => (uuid) => !!state.pendingActionsByUUID[uuid],
    getSelectedPatient: (state) => state.selectedPatient,
  },
  mutations: {
    setAsFetching(state, payload) {
      Object.keys(payload).forEach((prop) => {
        state.fetching[prop].isFetching = payload[prop]
      })
    },
    setAsPending(state, { uuid, status = true }) {
      if (status) {
        Vue.set(state.pendingActionsByUUID, uuid, true)

        return
      }
      Vue.delete(state.pendingActionsByUUID, uuid)
    },
    setAsCompleted(state, payload) {
      Object.keys(payload).forEach((prop) => {
        state.fetching[prop].completed = payload[prop]
      })
    },
    setTodoList(state, { type, patients, total }) {
      state.list[type] = { patients, total }
    },
    appendToTodoList(state, { type, patients, total }) {
      state.list[type] = { patients: { ...state.list[type].patients, ...patients }, total }
    },
    resetTodoList(state) {
      const rawState = generateDefaultState()

      Object.entries(rawState).forEach(([prop, value]) => {
        Vue.set(state, prop, value)
      })
    },
    removeItemFromTodoList(state, { prescriptionUuid, type = 'pp' }) {
      Vue.delete(state.list[type].patients, prescriptionUuid)
    },
    setSelectedPatient(state, patientData) {
      state.selectedPatient = patientData
    },
  },
  actions: {
    async fetchTodoList({ commit }, { offset, limit, type = 'pp', onSuccessMutation = 'setTodoList' }) {
      try {
        commit('setAsFetching', { [type]: true })
        const { data } = await Vue.$http('todoList/fetchProtocolProgressionTodoList', { offset, limit })

        commit(onSuccessMutation, { type, patients: data.list, total: data.total })
      } catch (error) {
        console.error('Error fetching todo list.', error)
      } finally {
        commit('setAsFetching', { [type]: false })
      }
    },
    removeItemFromTodoList({ commit, dispatch }, { prescriptionUuid, type = 'pp', offset }) {
      commit('removeItemFromTodoList', { prescriptionUuid, type })
      dispatch('fetchTodoList', { offset, limit: 1, type, onSuccessMutation: 'appendToTodoList' })
    },
    async updateExclusionRequestStatus({ commit, dispatch }, { id, status }) {
      try {
        commit('setAsPending', { uuid: id })
        const { data } = await Vue.$http('todoList/updateExclusionRequestStatus', { id, status })

        if (data.success) {
          dispatch('patients/setPatientPropertyState', data, { root: true })
          Vue.$notify.success(i18n.t('CHANGE_STATUS.NOTIFICATION.SUCCESS'))
        }
      } catch (e) {
        console.error(e)
        Vue.$notify.error(i18n.t('CHANGE_STATUS.NOTIFICATION.ERROR'))
      } finally {
        commit('setAsPending', { uuid: id, status: false })
      }
    },
  },
}
